import moment from 'moment';

const MomentUtils = {
  startOfResolution(dateTime, resolution) {
    let effectiveResolution = resolution;
    if (resolution === 'week') {
      effectiveResolution = 'isoWeek'; // Weeks should start on Monday :)
    }

    return moment(dateTime).startOf(effectiveResolution);
  },
};

export default MomentUtils;



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/graylog-project-cli-release/workspace/.repos/graylog2-server/graylog2-web-interface/src/util/MomentUtils.js